import React from 'react';
import styled from 'styled-components';

const E6Style = styled.svg``;

export const E6 = ({ color }) => {
	return (
		<E6Style
			xmlns='http://www.w3.org/2000/svg'
			width='20.772'
			height='25.559'
			viewBox='0 0 20.772 25.559'
		>
			<path
				id='Eiffel_Tower'
				data-name='Eiffel Tower'
				d='M970.12,598.052a50.284,50.284,0,0,0,2.094,9.032,44.5,44.5,0,0,0,3.661,8.282c.06.1.107.2.149.274h2.208a.573.573,0,0,1,0,1.145H958.588a.573.573,0,0,1,0-1.145h2.2l.156-.274a44.969,44.969,0,0,0,3.661-8.282,49.646,49.646,0,0,0,2.095-9.032.579.579,0,0,1-.459-.556v-2.851a.569.569,0,0,1,.574-.571h1.02V591.8a.574.574,0,0,1,1.148,0v2.276h1.026a.567.567,0,0,1,.568.571V597.5a.579.579,0,0,1-.459.556Zm3.134,17.588h0a5.378,5.378,0,0,0-9.686,0h9.686Zm-3.823-20.427h-2.04v1.709h2.04v-1.709Zm-1.918,8.707h1.8q-.548-2.19-.905-4.448c-.237,1.5-.54,2.988-.9,4.448Zm2.108,1.141h-2.413c-.216.79-.452,1.568-.7,2.33h3.8c-.244-.762-.481-1.54-.689-2.33Zm-4.244,5.479h6.066c-.256-.658-.512-1.323-.749-2h-4.566c-.237.679-.486,1.344-.751,2Zm6.54,1.145h-1.594a6.5,6.5,0,0,1,2.114,1.151c-.175-.378-.352-.763-.52-1.151Zm-5.418,0H964.9c-.175.389-.344.777-.514,1.158a6.379,6.379,0,0,1,2.108-1.158Z'
				transform='translate(-958.029 -591.226)'
				fill={color}
			/>
		</E6Style>
	);
};
